import $ from 'jquery';
import React from 'react';
import bg_img from '../images/Oxygen_customer_support.jpg';
import '../stylesheet/application.css';
import '../stylesheet/geosuggest.css';
import '../stylesheet/material.css';
import '../stylesheet/navbar.css';
import '../stylesheet/radiobuttonstyle.css';
import '../stylesheet/regtabs.css';
import Signin from './register/signin.jsx';

// const styles = {
//     stepbutton: {
//         fill: "rgb(48, 86, 151)"
//     },
//     focusStyle: {
//         borderTop: "none #333",
//         borderLeft: "none #333",
//         borderRight: "none #333",
//         borderBottom: "2px solid #333"
//     },
//     focusTextStyle: {
//         color: "#333"
//     }
// }

class Application extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: 0
        }
    }
    componentDidMount() {
        localStorage.setItem("loginState", false)
        
        if(localStorage.getItem('loginState') === "false" )
        {
            localStorage.clear();
        }
    }
    // handleLogin = () => {
    //     const { publicKey } = this.props
    //     const {activationcardState } = this.props
    //     const { expiryDate}= this.state
    //     let _this = this
    //     const public_Key = publicKey.body.publickey;
    //     let encrypt = new JSEncrypt();
    //     encrypt.setPublicKey(public_Key);
    //     // let expiryDate = _this.state.expiryDate;

    //     let state = {
    //         userName: this.state.userName,
    //         password: this.state.password,
    //         applicationId: "myrewards",
    //         cardNumber: encrypt.encrypt(localStorage.getItem('cdNo')),
    //         cardType: localStorage.getItem('cardTypes'),
    //         expiryDate: encrypt.encrypt(this.state.expiryDate),
    //         cardPin: encrypt.encrypt(_this.state.pin),
    //     }

    //     fetch(services.login, {
    //         method: 'POST',
    //         headers: new Headers({
    //             'Content-Type': 'application/json'
    //         }),
    //         body: JSON.stringify(state)
    //     })
    //         .then(
    //             function (response) {
    //                 if (response.status === 200 || response.status === 201) {

    //                     if (_this.state.userName === 'admin' && _this.state.password === 'Qwerty@1') {
    //                         response.json().then(function (json) {
    //                             let exp = json.expiryInMinutes

    //                             let expiry = (exp * 60000 + new Date().getTime())

    //                             localStorage.setItem('expiryTime', JSON.stringify(expiry))
    //                             localStorage.setItem("loginState", true)
    //                             localStorage.setItem('memberId', json.memberId);
    //                             localStorage.setItem('token', json.token)
    //                             localStorage.setItem('accountId', json.accountId);
    //                             localStorage.setItem('timeoutvalue', 'first')

    //                             localStorage.setItem('lastSuccessfulLogin', json.lastSuccessfulLogin);
    //                             localStorage.setItem('lastUnsuccessfulLogin', json.lastUnsuccessfulLogin);
    //                             localStorage.setItem('cardTypes', json.cardTypes)
    //                             _this.setState({
    //                                 loader: false
    //                             })
    //                             toast.success(response.headers.get('message'), {
    //                                 position: "top-right",
    //                                 draggablePercent: 60,
    //                                 autoClose: 3000,
    //                                 hideProgressBar: false,
    //                                 closeOnClick: true,
    //                                 pauseOnHover: true,
    //                                 draggable: false
    //                             });

    //                             setTimeout(function () {
    //                                 _this.props.history.push('/cardsearch');
    //                             }, 3000);
    //                         })
    //                 
    //                     }
                   
    //                 }
                 
    //             }
    //         )

    // }


    render() {
        const height = $(window).height()
        return (
            <div className="row">
            <div className="col-sm-12" style={{ backgroundImage: `url(${bg_img})`,minHeight: height,backgroundSize:"cover"}}>
                {/* <GusetNavbar /> */}
                <div className="offset-sm-1 col-sm-11">
                    <Signin/>
                </div>
                </div>
            </div>
        );
    }
}



export default Application;



// WEBPACK FOOTER //
// ./src/components/application.jsx